<template>
  <template v-if="typeContextCourant === TypesContextesAutorisesEnum.Prestataire">
    <BasicText>
      En tant que prestataire vous pouvez pré-saisir une demande de formation et la soumettre à l’employeur pour
      validation.
    </BasicText>
    <BasicText>
      Pour votre information, l'adresse e-mail de l'employeur est indispensable lors de la saisie de la demande. Elle
      permettra l'envoi d'un e-mail informant l'employeur de la pré-saisie de la demande de formation. Celui-ci pourra
      ainsi vérifier l'exactitude des données saisies et aura la possibilité d'accepter ou de refuser la demande.
    </BasicText>
    <BasicText>
      Si la demande est acceptée et transmise à AKTO, vous recevrez une notification d’accord. En revanche, si
      l'employeur refuse de reprendre la demande, vous en serez informé.
    </BasicText>
    <BasicText>Pour vous aider dans la saisie de la demande, vous trouverez ci-dessous des liens utiles.</BasicText>
    <BasicText>
      <ul>
        <li
          v-for="(urlLabel, i) in urlLabelsPrestataire"
          :key="i"
        >
          <BasicLink
            :label="urlLabel.label"
            @link-click="redirectExterne(urlLabel.url)"
          />
        </li>
      </ul>
    </BasicText>
  </template>
  <template v-else>
    <BasicText v-if="model?.sousDispositif! === 'CleaSocleCompetence'">
      <BasicText weight="bold">CléA</BasicText>
      est un dispositif qui permet de financer des certifications, ayant pour but de prouver la maitrise des savoir de
      base.
    </BasicText>
    <BasicText v-if="model?.sousDispositif! === 'Fse'">
      Le Fond Social Européen permet de promouvoir l’emploi, la formation tout au long de la vie et l’inclusion sociale.
      Grâce au FSE, AKTO peut financer jusqu’à 50% les actions de formation. Avant de déposer une demande pour une
      action de formation financée par un fonds public, renseignez-vous sur les règles applicables et les dispositions
      particulières prévues par le financeur ainsi que celles liées spécifiquement à votre convention et à vos accords
      collectifs de branche (exemple la nature ou la durée des actions éligibles, le montant du financement). Pour toute
      demande de financement public, il est impératif de vous rapprocher de votre conseiller pour préparer le projet en
      amont et bien formaliser la demande dans le respect du cadre en vigueur.
    </BasicText>
    <template v-if="model?.sousDispositif! === 'PicIae'">
      <BasicText>
        Pour toute demande de financement public, il est impératif de vous rapprocher de votre conseiller pour préparer
        le projet en amont et bien formaliser la demande dans le respect du cadre en vigueur.
      </BasicText>
      <BasicText weight="bold">Prise en charge financière :</BasicText>
      <BasicText>
        <ul>
          <li>
            <p><BasicText weight="bold">Si vous êtes une structure de 250 salariés ou moins :</BasicText></p>
            <p>
              La prise en charge du PIC IAE s’élève à 70 % de l’assiette éligible. Les 30% restant sont à votre charge
              (Versements volontaires ou Fonds conventionnels selon la Branche).
            </p>
          </li>
          <li>
            <p><BasicText weight="bold">Si vous êtes une structure de plus de 250 salariés :</BasicText></p>
            <p>
              La prise en charge du PIC IAE s’élève à 60 % de l’assiette éligible. Les 40% restant sont à votre charge
              (Versements volontaires ou Fonds conventionnels selon la Branche).
            </p>
          </li>
        </ul>
      </BasicText>
      <BasicText>
        <BasicText weight="bold">Assiette éligible =</BasicText>
        100% coûts pédagogiques + 100% frais annexes + forfait rémunération (13€/h pour les AI, EI et ETTI, 1,3€/h pour
        les ACI).
      </BasicText>
      <BasicText weight="bold">Entreprises éligibles</BasicText>
      <BasicText>
        <ul>
          <li>Ateliers Chantiers d’Insertion (ACI)</li>
          <li>Associations Intermédiaires (AI)</li>
          <li>Entreprises d’Insertion (EI)</li>
          <li>Entreprise de travail temporaire d’insertion (ETTI)</li>
        </ul>
      </BasicText>
      <BasicText weight="bold">Public éligible</BasicText>
      <BasicText>Exclusivement les salariés en insertion</BasicText>
      <!--
      <BasicText weight="bold">Dispositifs éligibles</BasicText>
      <BasicText>
        <ul>
          <li>Le plan de développement des compétences (parcours < à 70h pour les ETTI)</li>
          <li>Le CIPI (Contrat d’insertion professionnelle intérimaire)</li>
          <li>Le CDPI (Contrat de développement professionnel intérimaire)</li>
        </ul>
      </BasicText>
      -->
    </template>
    <template v-if="model?.sousDispositif! === 'AfFpe'">
      <BasicText>
        Avant de déposer une demande pour une action de formation , renseignez-vous sur les règles applicables ainsi que les dispositions particulières prévues par votre convention et les accords collectifs de branche (Exemple la nature ou la durée des actions éligibles, le montant du financement). N’hésitez pas à vous rapprocher de votre conseiller.
      </BasicText>
      <BasicText>
        C’est un dispositif du Fonds professionnel pour l’emploi dans le travail temporaire (FPETT) dont la gestion administrative est assurée par AKTO.
      </BasicText>
    </template>
    <BasicText v-if="model?.sousDispositif! === 'AbondementCpf'">
      Avant de déposer une demande pour une certification enregistrée au RNCP ou RS, renseignez-vous sur les règles
      applicables.
    </BasicText>

    <BasicText
      v-if="['TuteurMAitreApprentissage', 'CleaSocleCompetence', 'PDC'].includes(model?.sousDispositif!) === true"
    >
      Avant de déposer une demande pour une action de formation , renseignez-vous sur les règles applicables ainsi que
      les dispositions particulières prévues par votre convention et les accords collectifs de branche (Exemple la
      nature ou la durée des actions éligibles, le montant du financement). N’hésitez pas à vous rapprocher de votre
      conseiller.
    </BasicText>

    <BasicText v-if="['CleaSocleCompetence', 'PDC', 'ActionStandard'].includes(model?.sousDispositif!)">
      <BasicText weight="bold">AKTO</BasicText>
      peut financer les actions d’après les critères définis par votre branche professionnelle en lien avec ses
      priorités de formation.
    </BasicText>



    <BasicText>
      Pour vous aider dans la compréhension du dispositif et la saisie de la demande, vous trouverez ci-dessous des
      liens utiles.
    </BasicText>

    <BasicText>
      <ul>
        <li
          v-for="(urlLabel, i) in urlLabels"
          :key="i"
        >
          <BasicLink
            :label="urlLabel.label"
            @link-click="redirectExterne(urlLabel.url)"
          />
        </li>
      </ul>
    </BasicText>
  </template>
  <WrapperCheckbox
    v-model="validationNotice"
    :alertLabel="meta.validationNotice?.$messageErreurDirty!"
    :readonly
  >
    <BasicText>
      J'ai pris connaissance de la
      <BasicLink
        label="notice"
        @link-click="redirectExterne(urlNotice)"
      />
      comprenant les informations liées au traitement des données à caractère personnel.
    </BasicText>
  </WrapperCheckbox>
</template>

<script setup lang="ts">
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { UrlLabel } from '@/features/interface/shared/tools'
import { redirectExterne } from '@/features/shared/tools/url'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useDemandeAFStore } from '../../useDemandeAFStore'

  const store = useDemandeAFStore()
  const { model, meta, readonly, typeContextCourant } = storeToRefs(store)
  const { setupFieldWithKey } = store

  const validationNotice = setupFieldWithKey<boolean>('validationNotice')

  const urlLabels = computed(() => {
    const urlsLabels: UrlLabel[] = []
    urlsLabels.push({
      label: 'Les règles de prise en charge',
      url: model.value?.sousDispositif === 'AfFpe' ? 'https://www.fpett.fr/les-budgets-fpett/)' : 'https://www.akto.fr/financer-une-formation/regles-de-prise-en-charge/',
    })

    if (model.value?.sousDispositif === 'BilanCompetences') {
      urlsLabels.push({
        label: 'Bilan de compétences service public',
        url: 'https://www.service-public.fr/particuliers/vosdroits/F3087',
      })
      urlsLabels.push({
        label: 'Bilan de compétences AKTO',
        url: 'https://www.akto.fr/bilan-competences/',
      })
      urlsLabels.push({
        label: 'Financer une action de formation',
        url: 'https://www.akto.fr/financer-une-formation/process-de-depot-de-contrat-en-alternance-dossier-formation/',
      })
    }

    if (model.value?.sousDispositif === 'ValidationAcquisExperiences') {
      urlsLabels.push({
        label: 'VAE service public',
        url: 'https://travail-emploi.gouv.fr/la-validation-des-acquis-de-lexperience-vae',
      })
      urlsLabels.push({
        label: 'VAE AKTO',
        url: 'https://www.akto.fr/validation-acquis-experience/',
      })
    }

    if (model.value?.sousDispositif === 'AbondementCpf') {
      urlsLabels.push({
        label: 'CPF service public',
        url: 'https://financeurs.moncompteformation.gouv.fr/espace-public',
      })
      urlsLabels.push({
        label: 'Abondement CPF AKTO',
        url: 'https://www.akto.fr/compte-personnel-de-formation/',
      })
    }

    if (model.value?.sousDispositif === 'TuteurMAitreApprentissage') {
      urlsLabels.push({
        label: 'Tuteur / Maitre d’apprentissage AKTO',
        url: 'https://www.akto.fr/recruter-en-alternance/le-tutorat/',
      })
      urlsLabels.push({
        label: 'Guide pratique tuteur',
        url: 'https://www.akto.fr/content/uploads/2022/12/AKTO_GUIDE_PRATIQUE_TUTEUR-MAITRE-DAPPRENTISSAGE.pdf',
      })
    }

    if (model.value?.sousDispositif === 'CleaSocleCompetence') {
      urlsLabels.push({
        label: 'Certification de connaissances et de compétences professionnelles',
        url: 'https://www.certificat-clea.fr/',
      })
    }
    if (model.value?.sousDispositif === 'PDC' || model.value?.sousDispositif === 'ActionStandard') {
      urlsLabels.push({
        label: 'PDC service public',
        url: 'https://www.service-public.fr/particuliers/vosdroits/F11267',
      })
      urlsLabels.push({
        label: 'PDC site AKTO',
        url: 'https://www.akto.fr/plan-developpement-competences-salarie/',
      })
    }

    if (model.value?.sousDispositif === 'Fne') {
      urlsLabels.push({
        label: 'FNE AKTO',
        url: 'https://www.akto.fr/tout-savoir-sur-le-fne-formation-2024-laide-financiere-pour-former-les-salaries-de-votre-entreprise/',
      })
    }

    if (model.value?.sousDispositif === 'Fse') {
      urlsLabels.push({
        label: 'Cadre d’intervention FSE+',
        url: 'https://www.akto.fr/beneficier-dune-aide-du-fse-en-2025-comment-faire/',
      })
    }


    urlsLabels.push({
      label: 'Le mode opératoire',
      url: model.value?.sousDispositif === 'AfFpe' ?'https://ressourcesstatiques.akto.fr/guide/v2/GuideAfFpe.pdf'  : 'https://ressourcesstatiques.akto.fr/guide/v2/GuideActionFormation.pdf',
    })
    return urlsLabels
  })

  const urlLabelsPrestataire = computed(() => {
    const urlsLabels: UrlLabel[] = []

    urlsLabels.push({
      label: 'Le mode opératoire',
      url: 'https://ressourcesstatiques.akto.fr/guide/v2/GuideActionFormationPrestataire.pdf',
    })
    return urlsLabels
  })

  const urlNotice = computed(() => {
    const urlResource = import.meta.env.VITE_RESSOURCES_STATIQUES
    return model.value?.sousDispositif === 'AfFpe' ? urlResource + '/notice/NoticeAfFpe.pdf' : 'https://www.akto.fr/content/uploads/2023/05/NOTICE-POUR-LES-ACTIONS-DE-FORMATION.pdf'
  })
</script>

